/**
* @summary - Component that Provides License Type Code Creation Page
* @author Aro J
* @since 2024-06-28
*/
import { Box, Grid } from "@mui/material";
import axios from "axios";
import { parse } from 'date-fns';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { DefaultCard } from "../../assets/styled-components/card";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import { MasterGraph, ifacSecurityURL } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId, getcompanyId } from "../../utility/tokenUtility";
import utils from "../../utility/utilities";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomFooter from "../commoncomponents/CustomFooter";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import PageTitle from "../commoncomponents/PageTitle";

const CreateDocumentSerialNumber = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [transactiondesc, settransactiondesc] = useState('');
  const [site, setsite] = useState('');
  const [transactiondescOptions, setServiceOptions] = useState([]);
  const [prefix, setprefix] = useState('');
  const [docvalue, setdocvalue] = useState('');
  const [suffix, setsuffix] = useState('');
  const [transactioncode, setTransactioncode] = useState('');
  const [masdocumenttransactioncodeid, setMasdocumenttransactioncodeid] = useState('');
  const [dialogContent, setDialogContent] = useState('');
  const [isAddNew, setIsAddNew] = useState(false);
  const [openValidationDialog, setOpenValidationDialog] = useState(false);
  const [readOnlyEdit, setReadOnlyEdit] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  // const [effectivedate, handleLnDescChange] = useState("");
  const [id, setId] = useState("");
  const [facilityCode, setFacilityCode] = useState('');
  const dispatch = useDispatch();
  const [hospitalCodeOptions, setHospitalCodeOptions] = useState([]);
  const [rowData, setRowData] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const [expirydate, setExpirydate] = useState(utils.getCurrentDateFormatted("DD-MM-YYYY"));
  const [effectivedate, setEffectivedate] = useState(utils.getCurrentDateFormatted("DD-MM-YYYY"));


  const [defaultValue, setDefaultValue] = useState('');


  const [errors, setErrors] = useState({
    transactiondesc: false,
    prefix: false,
    docvalue: false,
    suffix: false,
    effectivedate: false,
    expirydate: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    transactiondesc: '',
    prefix: '',
    docvalue: '',
    suffix: '',
    effectivedate: '',
    expirydate: '',
  });

  const token = getAuthToken("id_token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const facilityid = getFacilityId('facilityid');
  const companyid = getcompanyId('companyid');

  useEffect(() => {
    fetchEditData();
    fetchServiceOptions();
    fetchHospitalCodeOptions();
  }, []);

  const fetchEditData = () => {
    settransactiondesc("");
    setprefix("");
    setdocvalue("");
    setsuffix("");
    setEffectivedate(utils.getCurrentDateFormatted("DD-MM-YYYY"));
    setExpirydate(utils.getCurrentDateFormatted("DD-MM-YYYY"));
  };

  const fetchServiceOptions = async () => {
    try {
      const responseTransCode = await axios.get(`${MasterGraph}/api/GraphDocumentSerialNumber/GetDocumentSerialNumberDetailsbyFacilityid/${facilityid}`, config);

      setServiceOptions(responseTransCode.data.map(option => ({
        ...option,
        label: option.transactiondesc,
        value: option.transactiondesc,
        id: option.id,
        //  masdocumenttransactioncodeid: option.masdocumenttransactioncodeid,
        effectivedate: utils.formatDate({ dateString: option.effectivedate, dbdate: true, format: 'dd/mm/yyyy' }),
        expirydate: utils.formatDate({ dateString: option.expirydate, dbdate: true, format: 'dd/mm/yyyy' }),
      })));
    } catch (error) {
      console.error("Error fetching service options:", error);
    }
  };


  const fetchHospitalCodeOptions = async () => {
    try {
      // Clear any existing facility code before fetching new data
      localStorage.removeItem('facilitycode');

      const response = await axios.get(`${ifacSecurityURL}/api/GraphUserdetails/Locationbasedoncompantid/${companyid}?size=1000`, config);
      const hospitalCodeData = response.data;

      // Replace 'yourFacilityId' with the actual facility ID you want to filter by
      const yourFacilityId = facilityid;

      // Filter the data based on the facilityid
      const filteredData = hospitalCodeData.filter(code => code.id === yourFacilityId);

      if (filteredData.length > 0) {
        const options = filteredData.map(code => ({
          value: code.facilityname,
          label: code.facilitycode,
          id: code.id
        }));

        // Store the facilitycode of the filtered item in localStorage
        localStorage.setItem("facilitycode", filteredData[0].facilitycode);

        // Update state with the new options
        setHospitalCodeOptions(options);
        setFacilityCode(filteredData[0].facilitycode); // Update the current facility code in state
      } else {
        console.log(`No data found for facility ID: ${yourFacilityId}`);
      }
    } catch (error) {
      console.error("Error fetching Hospital Code options:", error);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    let formIsValid = true;
    const newErrors = {
      transactiondesc: false,
      prefix: false,
      docvalue: false,
      suffix: false,
      effectivedate: false,
      expirydate: false
    };
    const newErrorMessages = {
      transactiondesc: '',
      prefix: '',
      docvalue: '',
      suffix: '',
      effectivedate: '',
      expirydate: ''
    };

    if (!transactiondesc) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, transactiondesc: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, transactiondesc: 'Transaction is required' }));

    }
    if (!prefix && transactiondesc) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, prefix: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, prefix: 'Prefix is required' }));

    }

    if (!docvalue && transactiondesc) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, docvalue: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, docvalue: 'Docvalue is required' }));
    }

    if (!suffix && transactiondesc) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, suffix: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, suffix: 'Suffix is required' }));
    }

    if (!effectivedate && transactiondesc) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, effectivedate: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, effectivedate: 'Effectivedate is required' }));

    }
    if (!expirydate && transactiondesc) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, expirydate: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, expirydate: 'Expirydate is required' }));

    }


    if (!Object.values(errorMessages).every(value => value === '')) {
      formIsValid = false
    }

    if (formIsValid) {
      handleSave();
    }
  };

  const handleSave = async () => {

    try {
      const payload = {

        facilityid,
        id: transactiondesc.id,
        docvalue,
        suffix,
        effectivedate: utils.formatDate({
          dateString: effectivedate,
          format: "YYYY-MM-DD",
          includeTime: true,
        }),
        expirydate: utils.formatDate({
          dateString: expirydate,
          format: "YYYY-MM-DD",
          includeTime: true,
        }),
        masdocumenttransactioncodeId:transactiondesc.masdocumenttransactioncodeid
        // masdocumenttransactioncode: {

        //   id: transactiondesc.masdocumenttransactioncodeid,
        //   transactioncode: transactiondesc.transactioncode,
        //   transactiondesc: transactiondesc.transactiondesc,
        //   prefix: prefix,

        // }
      };


      const response = await axios.put(`${MasterGraph}/api/masdocumentsequencenos/${transactiondesc.id}`, payload, config);

      if (response.status === 200) {
        setOpenValidationDialog(true);
        setDialogContent('Data updated successfully.');
        setIsChanged(false);
        fetchServiceOptions();
        fetchHospitalCodeOptions();


      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setErrorMessage("Document Serial Number Already Exists");
      } else {
        setErrorMessage("error");
      }
    }
  };

  const handleCancel = () => {
    if (!isChanged) {
      // navigate(-1, { replace: true });
      navigate("/dashboard");
      dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
      dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
    }

    else {
      setCancelDialogOpen(true);
      setDialogContent("Record(s) not Saved/Updated. Do you want to continue?");
    }
  };

  const handleConfirmCancel = () => {
    setCancelDialogOpen(false);
    setOpenValidationDialog(false);
    if (isChanged && !openValidationDialog) {
      setCancelDialogOpen(false);
      navigate(-1, { replace: true });
    }
  };
  const handletransactiondescChange = (newValue) => {

    settransactiondesc(newValue);
    if (newValue) {
      setErrors({});
      setErrorMessages({});
      setprefix(newValue.prefix);
      setdocvalue(newValue.docvalue);
      setsuffix(newValue.suffix);
      setExpirydate(newValue.expirydate);
      setEffectivedate(newValue.effectivedate);
    }

  };

  const handleSiteChange = (newValue) => {
    setFacilityCode(newValue);
    // Update the localStorage with the new facility code
    localStorage.setItem('facilitycode', newValue);
  };

  const handleprefixChange = (newValue) => {
    setprefix(newValue);
    setIsChanged(true);
    const regex = /^[a-zA-Z0-9]*$/;


    if (!regex.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, prefix: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, prefix: 'Invalid Characters in Prefix' }));
    }
    else if (newValue.startsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, prefix: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, prefix: 'Space not allowed at the beginning' }));
    }

    else if (newValue.includes('  ')) {
      setErrors((prevErrors) => ({ ...prevErrors, prefix: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, prefix: 'Double Space not allowed' }));
    }
    else {
      setErrors((prevErrors) => ({ ...prevErrors, prefix: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, prefix: '' }));
    }
  };

  const handledocvalueChange = (newValue) => {
    setdocvalue(newValue);
    setIsChanged(true);
    const regex = /^[0-9]*$/;
    if (!regex.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, docvalue: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, docvalue: 'Invalid Characters Value' }));
    }
    else if (newValue.startsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, docvalue: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, docvalue: 'Space not allowed at the beginning' }));
    }

    else if (newValue.includes('  ')) {
      setErrors((prevErrors) => ({ ...prevErrors, docvalue: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, docvalue: 'Double Space not allowed' }));
    }
    else {
      setErrors((prevErrors) => ({ ...prevErrors, docvalue: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, docvalue: '' }));
    }
  };

  const handlesuffixChange = (newValue) => {
    setsuffix(newValue);
    setIsChanged(true);
    const regex = /^[a-zA-Z0-9]*$/;
    if (!regex.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, suffix: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, suffix: 'Invalid Characters in Suffix' }));
    }
    else if (newValue.startsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, suffix: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, suffix: 'Space not allowed at the beginning' }));
    }

    else if (newValue.includes('  ')) {
      setErrors((prevErrors) => ({ ...prevErrors, suffix: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, suffix: 'Double Space not allowed' }));
    }
    else {
      setErrors((prevErrors) => ({ ...prevErrors, suffix: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, suffix: '' }));
    }
  };


  const handleeffectivedateChange = async (newValue) => {
    setEffectivedate(newValue);
    setIsChanged(true);
    if (newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, effectivedate: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, effectivedate: '' }));
    }
    await validateDates(newValue, expirydate);
  };

  const handleexpirydateChange = async (newValue) => {
    setExpirydate(newValue);
    setIsChanged(true);
    if (newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, expirydate: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, expirydate: '' }));
    }
    await validateDates(effectivedate, newValue);
  };

  const validateDates = async (effective, expiry) => {
    let newErrors = {};
    let newErrorMessages = {};

    if (effective && expiry) {
      const effectiveDate = parse(effective, 'dd/MM/yyyy', new Date());
      const expiryDate = parse(expiry, 'dd/MM/yyyy', new Date());
      if (effectiveDate >= expiryDate) {
        setErrors((prevErrors) => ({ ...prevErrors, expirydate: true }));
        setErrorMessages((prevMessages) => ({ ...prevMessages, expirydate: 'Expiry date not equal to Effective date' }));

      } else {
        setErrors((prevErrors) => ({ ...prevErrors, expirydate: false }));
        setErrorMessages((prevMessages) => ({ ...prevMessages, expirydate: '' }));

      }
    }
  };

  const handleDialogClose = () => {
    setCancelDialogOpen(false);
    setOpenValidationDialog(false)
  };

  useEffect(() => {
    // Fetch facility code options based on the current login
    fetchHospitalCodeOptions();

    // Optionally, you can also load from localStorage if required, but the priority is fetching fresh data.
    const storedFacilityCode = localStorage.getItem('facilitycode');
    if (storedFacilityCode) {
      setFacilityCode(storedFacilityCode);
    }

  }, [companyid, facilityid]);





  return (
    <>

      <PageTitle title={'Create Document Serial Number'} />
      <Box mt={{ xs: 1, md: 2 }}>
        <DefaultCard sx={{ height: "100%" }}>
          <form onSubmit={handleSubmit} style={{ position: "relative" }}>
            <Box mb={2}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={4}>
                  <CustomSelectInput
                    id="transaction-label"
                    label="Transaction"
                    autoFocus={true}
                    value={transactiondesc}
                    options={transactiondescOptions}
                    onChange={handletransactiondescChange}
                    disabled={readOnlyEdit}
                    isMandatoryField={true}
                    error={errors.transactiondesc}
                    errorMessage={errorMessages.transactiondesc}
                  />
                </Grid>

                <Grid item xs={6} md={4}>
                  <CustomTextField
                    maxlength={3}
                    id="site-label"
                    disabled={true}
                    label="Site"
                    value={facilityCode}
                    onChange={handleSiteChange}
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <CustomTextField
                    maxlength={3}
                    label="Prefix "
                    id="prefix-label"
                    disabled={!transactiondesc}
                    value={prefix}
                    onChange={handleprefixChange}

                    isMandatoryField={true}
                    error={errors.prefix}
                    errorMessage={errorMessages.prefix}
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <CustomTextField
                    maxlength={6}
                    id="docvalue-label"
                    disabled={!transactiondesc}
                    label="Value"
                    value={docvalue}
                    onChange={handledocvalueChange}
                    isMandatoryField={true}
                    error={errors.docvalue}
                    errorMessage={errorMessages.docvalue}
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <CustomTextField
                    maxlength={4}
                    id="asset-category-description"
                    disabled={!transactiondesc}
                    label="Suffix"
                    value={suffix}
                    onChange={handlesuffixChange}
                    isMandatoryField={true}
                    error={errors.suffix}
                    errorMessage={errorMessages.suffix}
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <CustomDatePicker
                    label="Effective Date"
                    isMandatoryField={true}
                    value={effectivedate}
                    id="effective"
                    disabled={!transactiondesc}
                    onChange={(date) => setEffectivedate(date)}
                    onDateChange={handleeffectivedateChange}
                    dateFormat="DD-MM-YYYY"
                    error={errors.effectivedate}
                    helperText={errorMessages.effectivedate}
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <CustomDatePicker
                    minimumDate={effectivedate}
                    label="Expiry Date"
                    isMandatoryField={true}
                    value={expirydate}
                    id="effective-from"
                    disabled={!transactiondesc}
                    onChange={(date) => setExpirydate(date)}
                    onDateChange={handleexpirydateChange}
                    // onDateChange={handleexpirydateChange}
                    dateFormat="DD-MM-YYYY"
                    error={errors.expirydate}
                    helperText={errorMessages.expirydate}
                  />
                </Grid>
              </Grid>
            </Box>
          </form>
          <CustomFooter
            cancelClick={handleCancel}
            saveClick={handleSubmit}
            showAddButton={false}
            buttonLabel="Save"
          />
        </DefaultCard>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: { xs: "center", md: "end" },
          }}
        >
        </Box>

      </Box>

      <CustomDialog
        open={cancelDialogOpen}
        onConfirm={handleConfirmCancel}
        onClose={handleDialogClose}
        content={dialogContent}
        confirmBtn={'Yes'}
        cancelBtn={'No'}
      />
      <CustomDialog
        open={openValidationDialog}
        onConfirm={handleConfirmCancel}
        onClose={handleDialogClose}
        content={dialogContent}
        confirmBtn={'Ok'}
      />
    </>
  );
};

export default CreateDocumentSerialNumber;
